<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
         <div class="card m-4 m-lg-3">
        <div class="card-body">
          <div class="row align-items-center rental-payment">
            <div class="col mt-4 d-none d-sm-block">
              <h4 class="ms-2">Edit {{ this.userRole }} Details</h4>
            </div>
             <div class="col mt-4 d-block d-sm-none">
              <h4 class="ms-2">Edit {{ this.userRole }}</h4>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-flex justify-content-end me-2 add-btn new-btn">
              <llp-button
                :load-spinner="showaddadminSpinner"
                classNames="btn-secondary me-2 d-none d-sm-block new-btn"
                @click="BackToUserDetails()"
              >
                Back To {{ this.userRole }}
              </llp-button>
               <llp-button
                :load-spinner="showaddadminSpinner"
                classNames="btn-secondary me-2 d-block d-sm-none new-btn"
                @click="BackToUserDetails()"
              >
                Go Back
              </llp-button>
            </div>
          </div>

          <form ref="laddadmin" class="d-grid table-data" @submit.prevent="EditUser">
            <div class="row p-2">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="firstName" :aria-label="FirstName">
                  First Name:
                </llp-label>
                <llp-input
                  id="firstName"
                  v-model:modelValue="adminData.firstName"
                  :errors="validator.adminData.firstName.$errors"
                ></llp-input>
                   <div v-if="formErrors.firstName" class="text-danger">
                    <span>{{ formErrors.firstName[0] }}</span>
                  </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="lastName" :aria-label="LastName">
                  Last Name:
                </llp-label>
                <llp-input
                  id="lastName"
                  v-model:modelValue="adminData.lastName"
                  :errors="validator.adminData.lastName.$errors"
                ></llp-input>
                 <div v-if="formErrors.lastName" class="text-danger">
                    <span>{{ formErrors.lastName[0] }}</span>
                  </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="mobile" :aria-label="Email"> Mobile: </llp-label>
                <llp-input
                  id="mobile"
                  v-model:modelValue="adminData.mobile"
                  :errors="validator.adminData.mobile.$errors"
                ></llp-input>
                 <div v-if="formErrors.mobile" class="text-danger">
                    <span>{{ formErrors.mobile[0] }}</span>
                  </div>
              </div>
            </div>
            <div class="row p-2">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="address" :aria-label="Address">
                  Address:
                </llp-label>
                <llp-input
                  id="address"
                  v-model:modelValue="adminData.address"
                  :errors="validator.adminData.address.$errors"
                ></llp-input>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="city" :aria-label="City"> City: </llp-label>
                <llp-input
                  id="City"
                  v-model:modelValue="adminData.city"
                  :errors="validator.adminData.city.$errors"
                ></llp-input>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="state" :aria-label="State"> State: </llp-label>
                <select
                  id="state"
                  class="form-control select-dropdown"
                  v-model="adminData.state"
                  :errors="validator.adminData.state.$errors"
                >
                  <option value="" disabled selected>Select your state</option>
                  <option value="Andhra Pradesh">Andhra Pradesh</option>
                  <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                  <option value="Assam">Assam</option>
                  <option value="Bihar">Bihar</option>
                  <option value="Chhattisgarh">Chhattisgarh</option>
                  <option value="Goa">Goa</option>
                  <option value="Gujarat">Gujarat</option>
                  <option value="Haryana">Haryana</option>
                  <option value="Himachal Pradesh">Himachal Pradesh</option>
                  <option value="Jammu and Kashmir">Jammu and Kashmir</option>
                  <option value="Jharkhand">Jharkhand</option>
                  <option value="Karnataka">Karnataka</option>
                  <option value="Kerala">Kerala</option>
                  <option value="Madhya Pradesh">Madhya Pradesh</option>
                  <option value="Maharashtra">Maharashtra</option>
                  <option value="Manipur">Manipur</option>
                  <option value="Meghalaya">Meghalaya</option>
                  <option value="Mizoram">Mizoram</option>
                  <option value="Nagaland">Nagaland</option>
                  <option value="Odisha">Odisha</option>
                  <option value="Punjab">Punjab</option>
                  <option value="Rajasthan">Rajasthan</option>
                  <option value="Sikkim">Sikkim</option>
                  <option value="Tamil Nadu">Tamil Nadu</option>
                  <option value="Telangana">Telangana</option>
                  <option value="Tripura">Tripura</option>
                  <option value="Uttar Pradesh">Uttar Pradesh</option>
                  <option value="Uttarakhand">Uttarakhand</option>
                  <option value="West Bengal">West Bengal</option>
                  <option value="Chandigarh">Chandigarh</option>
                  <option value="Lakshadweep">Lakshadweep</option>
                  <option value="Delhi">Delhi</option>
                  <option value="Puducherry">Puducherry</option>
                </select>
                <div
                  v-if="validator.adminData.state.$invalid"
                  class="text-danger"
                >
                  {{ validator.adminData.state.$errors[0]?.$message }}
                </div>
              </div>
            </div>
            <div class="row p-2">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="pinCode" :aria-label="PinCode">
                  Pincode:
                </llp-label>
                <llp-input
                  id="pinCode"
                  v-model:modelValue="adminData.pinCode"
                  :errors="validator.adminData.pinCode.$errors"
                ></llp-input>
                 <div v-if="formErrors.pincode" class="text-danger">
                    <span>{{ formErrors.pincode[0] }}</span>
                  </div> 
              </div>

               <!-- <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="aadhaarNumber" :aria-label="AadhaarNumber">
                  AadharNumber:
                </llp-label>
                <llp-input
                  id="aadhaarNumber"
                  v-model:modelValue="adminData.aadhaarNumber"
                  :errors="validator.adminData.aadhaarNumber.$errors"
                ></llp-input>
              </div> -->

              <!-- <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="status" :aria-label="Staus"> Status: </llp-label>
                <select
                  id="status"
                  class="form-control select-dropdown"
                  v-model="adminData.status"
                >
                  <option value="1">Active</option>
                  <option value="0">InActive</option>
                </select>
              </div> -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="email" :aria-label="email"> Email: </llp-label>
                <llp-input
                  id="email"
                  v-model:modelValue="adminData.email"
                  :errors="validator.adminData.email.$errors"
                ></llp-input>
                 <div v-if="formErrors.email" class="text-danger">
                <span>{{ formErrors.email[0] }}</span>
              </div>
              </div>
               <div class="col-lg-4 col-md-4 col-sm-6"  v-if="role === 'distributor' && (login_user_role_id == '1' || login_user_role_id == '2')">
                  <llp-label id="commissionLabel" :aria-label="Commission" >
                    Commission(%):
                  </llp-label>
                  <llp-input
                    id="CommissionId"
                    v-model:modelValue="adminData.Commission"
                     :errors="validator.adminData.Commission?.$errors"
                   
                  ></llp-input>
                   <div v-if="formErrors.Commission" class="text-danger">
                    <span>{{ formErrors.Commission[0] }}</span>
                  </div>
                </div>
            </div>

            <!-- <h5>Business Details</h5>
            <div class="row p-2">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="businessName" :aria-label="BusinessName">
                  Business Name:
                </llp-label>
                <llp-input
                  id="businessName"
                  v-model:modelValue="adminData.businessName"
                ></llp-input>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="contactNumber" :aria-label="ContactNumber">
                  Contact Number:
                </llp-label>
                <llp-input
                  id="contactNumber"
                  v-model:modelValue="adminData.contactNumber"
                  maxlength="10"
                ></llp-input>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label id="businessAddress" :aria-label="BusinessAddress">
                  BusinessAddress:
                </llp-label>
                <llp-input
                  id="businessAddress"
                  v-model:modelValue="adminData.businessAddress"
                ></llp-input>
              </div>
            </div>
            <div class="row p-2">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <llp-label
                  id="gst"
                  :aria-label="gstApplicable"
                  v-model="adminData.gst"
                >
                  GST Applicable:
                </llp-label>
                <div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="gstYes"
                      name="gstApplicable"
                      value="yes"
                      checked
                    />
                    <label class="form-check-label" for="gstYes">Yes</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="gstNo"
                      name="gstApplicable"
                      value="no"
                    />
                    <label class="form-check-label" for="gstNo">No</label>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="col">
              <div class="row mt-2 p-0">
                <div class="col d-flex justify-content-end">
                  <llp-button
                    :load-spinner="submitloadingSpinner"
                    classNames="btn-secondary back-to-btn"
                    type="submit"
                  >
                    Submit
                  </llp-button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, maxLength, numeric } from "@vuelidate/validators";
// import ErrorService from "../../../services/error.service";
import NetworkService from '@/services/network.service';

export default {
  setup: () => ({ validator: useVuelidate() }),
  data() {
    return {
      formErrors: {},
      addUserRole: "",
      roleId:'',
      id:'',
      userDetails:'',
      userId:localStorage.getItem('User_id'),
      login_user_role_id:localStorage.getItem('role_id'),
      submitloadingSpinner:false,
      adminData: {
        firstName: "",
        lastName: "",
        mobile: "",
        address: "",
        city: "",
        email: "",
        state: "",
        pinCode: "",
        initialWallet: "",
        // status: "1",
        // panNumber: "",
        // aadhaarNumber: "",
        // businessName: "",
        // contactNumber: "",
        // businessAddress: "",
        // gst: "yes",
        userRole:'',
        Commission:'',
        created_by:''
      },
    };
  },
watch: {
  '$route.params': {
    handler(newParams) {
      this.role = newParams.role;
      this.id = newParams.id;
      this.setRoleIdAndFetch();
      this.addUserRole = newParams.role;
      this.userRole = this.role.charAt(0).toUpperCase() + this.role.slice(1);
    },
    deep: true,
    immediate: true
  }
},


  
  validations() {
    return {
      adminData: {
        firstName: {
          required: helpers.withMessage("First name is required.", required),
           alphaOnly: helpers.withMessage(
          "First name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
        },
        lastName: {
          required: helpers.withMessage("Last name is required.", required),
           alphaOnly: helpers.withMessage(
          "Last name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
        },
        mobile: {
          required: helpers.withMessage("Mobile number is required.", required),
          numeric: helpers.withMessage(
            "Mobile number must be numeric.",
            numeric
          ),
          maxLength: helpers.withMessage(
            "Mobile number must be 10 digits.",
            maxLength(10)
          ),
          validMobile: helpers.withMessage(
            "Mobile number must start with 6, 7, 8, or 9.",
            (value) => (value ? /^[6789]\d{9}$/.test(value) : true)
          ),
        },
        address: {
          required: helpers.withMessage("Address is required.", required),
        },
        city: { required: helpers.withMessage("City is required.", required),
          alphaOnly: helpers.withMessage(
          "City should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
         },
        state: {
          required: helpers.withMessage("State is required.", required),
        },
        email: {
          required: helpers.withMessage("Email is required.", required),
          validFormat: helpers.withMessage(
    "Please enter a valid email address.",
    (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
  )
        },
       pinCode: {
          required: helpers.withMessage("Pin code is required.", required),
           numeric: helpers.withMessage("Pin code must contain only numbers.", numeric),
          maxLength: helpers.withMessage("Pin code must be 6 digits.", maxLength(6)),
        },
//       Commission: {
//   required: helpers.withMessage(
//     "Commission is required.",
//     () => ( this.login_user_role_id == 2 || this.login_user_role_id == 1)),
//   validFormat: helpers.withMessage(
//     "Commission must be a number with up to 2 decimal places (0.000).",
//     (value) => {
//       if (!value) return false;
//       return /^\d+(\.\d{1,3})?$/.test(value);
//     }
//   ),
//   maxCommission: helpers.withMessage(
//     "Commission must not be more than 00.000",
//     (value) => {
//       if (!value) return false; 
//       return parseFloat(value) <= 99.999;
//     }
//   ),
// },
Commission: {
  required: helpers.withMessage(
    "Commission is required.",
    (value, vm) => {
      return (vm.login_user_role_id === 1 || vm.login_user_role_id === 2)
        ? !!value
        : true; 
    }
  ),
  validFormat: helpers.withMessage(
    "Commission must be a number with up to 3 decimal places (0.000).",
    (value, vm) => {
      if (vm.login_user_role_id == 1 || vm.login_user_role_id == 2) return true;
      if (!value) return false;
      return /^\d+(\.\d{1,3})?$/.test(value);
    }
  ),
  maxCommission: helpers.withMessage(
    "Commission must not be more than 99.999",
    (value, vm) => {
      if (vm.login_user_role_id == 1 || vm.login_user_role_id == 2) return true;
      if (!value) return false;
      return parseFloat(value) <= 99.999;
    }
  ),
}

        // panNumber: {
        //   required: helpers.withMessage("Pan number is required.", required),
        // },
        // aadhaarNumber: {
        //   required: helpers.withMessage(
        //     "Aadhaar number is required.",
        //     required
        //   ),
        //   numeric: helpers.withMessage(
        //     "Aadhaar number must be numeric.",
        //     numeric
        //   ),
        //   maxLength: helpers.withMessage(
        //     "Aadhaar number must be 12 digits.",
        //     maxLength(12)
        //   ),
        // },
      },
    };
  },
  mounted() {
    this.setRoleIdAndFetch();
    this.fetchUserDetails();
  },

  methods: {
    setRoleIdAndFetch() {
      if (this.role == "admin") {
        this.roleId = 2;
      } else if (this.role == "distributor") {
        this.roleId = 3;
      } else if (this.role == "retailer") {
        this.roleId = 4;
      } else {
        this.roleId = "";
      }

    
    },
    BackToUserDetails() {
      this.$router.back();
    },
    async fetchUserDetails()
    {
     try {
      const response = await NetworkService.get(`user-details/${this.roleId}/${this.id}/${this.userId}`)
      console.log("res",response.user.created_by);
      
     this.userDetails = response;
     console.log("line 459", this.userDetails);
     
     this.adminData.firstName = this.userDetails.user.user_details.first_name;
     this.adminData.lastName = this.userDetails.user.user_details.last_name;
     this.adminData.mobile = this.userDetails.user.mobile;
     this.adminData.address = this.userDetails.user.user_details.address;
     this.adminData.city = this.userDetails.user.user_details.city;
     this.adminData.state = this.userDetails.user.user_details.state;
     this.adminData.pinCode = this.userDetails.user.user_details.pincode;
    //  this.adminData.status = this.userDetails.user.status;
     this.adminData.email = this.userDetails.user.email;
     this.adminData.Commission =  this.userDetails.user.commission;
      this.created_by = response.user.created_by
     } catch (error) {
       this.$refs.toast.show("Unable to fetch the user details.", "error");
     }
     
    },
   async EditUser() {
  console.log("This is edit profile");

  try {
    const isValid = await this.validator.$validate();
    if (!isValid) {
      return;
    }

    console.log("This is edit profile line 477");
    this.submitloadingSpinner = true;

    const updateDetails = {
      parent_id: this.userId,
      first_name: this.adminData.firstName,
      last_name: this.adminData.lastName,
      state: this.adminData.state,
      email: this.adminData.email,
      city: this.adminData.city,
      address: this.adminData.address,
      mobile: this.adminData.mobile,
      pincode: this.adminData.pinCode,
      role: this.roleId,
      created_by: this.created_by
    };

    if (this.role === 'distributor') {
      updateDetails.commission = this.adminData.Commission;
    }

    console.log("Prepared updateDetails:", updateDetails);
    const response = await NetworkService.post(`user-update/${this.id}`, updateDetails);
    this.formErrors = {};
    this.$refs.toast.show(response.data.message);
    this.submitloadingSpinner = false;
    setTimeout(() => {
      this.$router.back();
    }, 3000);

  } catch (error) {
    this.submitloadingSpinner = false;
    const apiError = error?.errors;
    if (apiError) {
      this.formErrors = apiError;
    } else {
      this.$refs.toast.show("Unable to update the user details.", "error");
    }
  }
}

  },
};
</script>
